export default __webpack_public_path__ + "static/N0083-086ee148e76ba7afd70311b2a8603c7e.png";